<template>
  <router-view />
</template>

<script>
export default {
  name: 'Content'
  // child's container
}
</script>



// WEBPACK FOOTER //
// src/views/Content/Content.vue